import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {
  compose,
} from 'recompose';
import hasRESTClient from '../../hocs/has-rest-client';
import hasUserInfo from '../../hocs/has-user-info';
import {
  ORGANISATION_RESOURCE,
} from '../../utils/helpers/resources';

import InfluencerRatesTable from '../../components/influencer-rates-table';

class InfluencerPostRates extends Component {
  constructor() {
    super();
    this.state = { loading: true };
  }

  componentWillMount = () => {
    const {
      userInfo: {
        organisationId,
      },
      restClient,
    } = this.props;

    this.setState({
      loading: true,
    });
    restClient.get(`organisations/${organisationId}`)
      .then(organisationResource => {
        const {
          data: {
            data: { attributes },
          },
        } = organisationResource;
        return this.setState({ organisation: attributes, loading: false });
      })
      .catch(err => {
        this.setState({
          loading: false,
          error: err,
        });
      });
  }

  handleSave = data => {
    const {
      facebook,
      instagram,
      twitter,
      youtube,
      tiktok,
      twitch,
      snapchat,
      telegram,

      facebookRates,
      instagramRates,
      twitterRates,
      youtubeRates,
      tiktokRates,
      twitchRates,
      snapchatRates,
      telegramRates,

      othersRates,

    } = data;
    const influencerPatch = this.patchInfluencer({
      facebook,
      instagram,
      twitter,
      youtube,
      tiktok,
      twitch,
      snapchat,
      telegram,
    });

    const networkRates = [
      { network: 'facebook', ...facebookRates },
      { network: 'instagram', ...instagramRates },
      { network: 'twitter', ...twitterRates },
      { network: 'youtube', ...youtubeRates },
      { network: 'tiktok', ...tiktokRates },
      { network: 'twitch', ...twitchRates },
      { network: 'snapchat', ...snapchatRates },
      { network: 'telegram', ...telegramRates },
      { network: 'others', ...othersRates },
    ];
    const influencerDetailsPatch = this.patchInfluencerDetails({
      networkRates,
    });

    return Promise.all([influencerPatch, influencerDetailsPatch]);
  }

  patchInfluencer = patch => {
    const {
      influencer: {
        id,
      },
      restClient,
    } = this.props;

    const requestData = {
      data: {
        attributes: patch,
      },
    };
    return restClient.patch(`/influencer/${id}`, requestData).then(r => r.data);
  }

  patchInfluencerDetails = patch => {
    const {
      influencerDetails: { id },
      restClient,
    } = this.props;
    const requestData = {
      data: {
        attributes: patch,
      },
    };
    return restClient.patch(`/influencerDetails/${id}`, requestData);
  }

  render() {
    const {
      influencer,
      influencerDetails,
    } = this.props;
    const {
      loading,
      organisation,
      error,
    } = this.state;
    const {
      defaultCurrency,
    } = organisation || {};
    const {
      facebook, youtube, instagram, twitter, tiktok, twitch, snapchat, telegramUser,
      facebookCount, instagramCount, twitterCount, youtubeCount, tiktokCount, twitchCount,
      youtubeChannelTitle,
    } = influencer || {};
    const {
      networkRates,
    } = influencerDetails || {};
    const facebookRates = _.find(networkRates, ['network', 'facebook']);
    const instagramRates = _.find(networkRates, ['network', 'instagram']);
    const youtubeRates = _.find(networkRates, ['network', 'youtube']);
    const twitterRates = _.find(networkRates, ['network', 'twitter']);
    const tiktokRates = _.find(networkRates, ['network', 'tiktok']);
    const twitchRates = _.find(networkRates, ['network', 'twitch']);
    const snapchatRates = _.find(networkRates, ['network', 'snapchat']);
    const telegramRates = _.find(networkRates, ['network', 'telegram']);
    const othersRates = _.find(networkRates, ['network', 'others']);
    if (loading) return null;
    if (error) return (<pre>{JSON.stringify(error)}</pre>);
    return (
      <div className="page-content">
        <InfluencerRatesTable
          currency={defaultCurrency}
          facebook={facebook} facebookCount={facebookCount} facebookRates={facebookRates}
          youtube={youtube} youtubeCount={youtubeCount} youtubeRates={youtubeRates}
          youtubeChannelTitle={youtubeChannelTitle}
          instagram={instagram} instagramCount={instagramCount} instagramRates={instagramRates}
          twitter={twitter} twitterCount={twitterCount} twitterRates={twitterRates}
          tiktok={tiktok} tiktokCount={tiktokCount} tiktokRates={tiktokRates}
          twitch={twitch} twitchCount={twitchCount} twitchRates={twitchRates}
          snapchat={snapchat} snapchatRates={snapchatRates}
          telegram={twitter} telegramRates={telegramRates}
          others="others" othersRates={othersRates}

          onSave={this.handleSave}
        />
      </div>
    );
  }
}

InfluencerPostRates.propTypes = {
};

export default compose(
  hasRESTClient,
  hasUserInfo,
)(InfluencerPostRates);



/** WEBPACK FOOTER **
 ** ./src/containers/influencer-post-rates/index.js
 **/